export const families = [
    {
      id: '1',
      codigo_familia: 'Hogar1',
      codigo_hogar: "654321",
      apto:201,
      direccion: 'CR 56 # 67 -8 AP 405',
      integrantes: [
        {
          Documento_Identidad: 'CC-7889',
          Fecha_Nacimiento: '23/11/1990',
          Primer_Nombre: 'Luz',
          Segundo_Nombre: 'Karen',
          Primer_Apellido: 'Rodas',
          Segundo_Apellido: 'Robledo',
        },
        {
          Documento_Identidad: 'TI-8559',
          Fecha_Nacimiento: '30/12/2015',
          Primer_Nombre: 'Juliana',
          Segundo_Nombre: 'Rodolf',
          Primer_Apellido: 'Smith',
          Segundo_Apellido: 'Rodas',
        },
        {
          Documento_Identidad: 'TI-15684',
          Fecha_Nacimiento: '14/02/2020',
          Primer_Nombre: 'Mateo',
          Segundo_Nombre: 'Rodolf',
          Primer_Apellido: 'Smith',
          Segundo_Apellido: 'Rodas',
        },
      ],
    },
    {
      id: '2',
      codigo_familia: 'Hogar2',
      codigo_hogar: "5454656",
      apto:202,
      direccion: 'CL 7 SUR # 67A - 8 TORRE 2 AP 506',
      integrantes: [
        {
          Documento_Identidad: 'CC-616584',
          Fecha_Nacimiento: '08/09/1958',
          Primer_Nombre: 'Albert',
          Segundo_Nombre: 'Rodolf',
          Primer_Apellido: 'Smith',
          Segundo_Apellido: 'Julianny',
        },
        {
          Documento_Identidad: 'CC-651681',
          Fecha_Nacimiento: '08/09/1955',
          Primer_Nombre: 'Luzmila',
          Segundo_Nombre: 'Mirlakova',
          Primer_Apellido: 'MacKornic',
          Segundo_Apellido: 'White',
        },
      ],
    },
  ]